<template>
    <span class="is-size-7-mobile is-size-6 mr-1">
        {{ mergedResult.academyName }}:
        <span class="has-text-weight-bold"> {{ mergedResult.points }} {{ translate("page.admin_academy_results.earned_points") }} </span>
    </span>

    <div class="ml-4">
        <div v-for="(ruleBreakdown, index) in mergedResult.ruleBreakdowns" :key="index">
            <div v-if="ruleBreakdown.type === 'wonMatchesBreakdown'">
                {{ translate("page.admin_academy_results.wins") }}:
                <span class="has-text-success">{{ ruleBreakdown.value.wonMatches }}</span>
            </div>
            <template v-if="ruleBreakdown.type === 'awardedMedalsBreakdown'">
                <span>{{ translate("page.admin_academy_results.medals") }}:</span>

                <span class="academy-medal p-0">
                    <span class="is-gold has-text-weight-bold mr-1">
                        {{ getMedalCounter(ruleBreakdown, 1) }}
                    </span>
                    <span class="mr-1">/</span>
                    <span class="is-silver has-text-weight-bold mr-1">
                        {{ getMedalCounter(ruleBreakdown, 2) }}
                    </span>
                    <span class="mr-1">/</span>
                    <span class="is-bronze has-text-weight-bold mr-1">
                        {{ getMedalCounter(ruleBreakdown, 3) }}
                    </span>

                    <template v-if="useExtendedClassification">
                        <template v-if="!medalsSchema || medalsSchema.includes(4)">
                            <span class="mr-1">/</span>
                            <span class="is-extended has-text-weight-bold mr-1">
                                {{ getMedalCounter(ruleBreakdown, 4) }}
                            </span>
                        </template>

                        <span class="mr-1">/</span>
                        <span class="is-extended has-text-weight-bold mr-1">
                            {{ getMedalCounter(ruleBreakdown, 5) }}
                        </span>
                        <span class="mr-1">/</span>
                        <span class="is-extended has-text-weight-bold mr-1">
                            {{ getMedalCounter(ruleBreakdown, 7) }}
                        </span>
                        <span class="mr-1">/</span>
                        <span class="is-extended has-text-weight-bold mr-1">
                            {{ getMedalCounter(ruleBreakdown, 8) }}
                        </span>
                    </template>
                </span>
            </template>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { AwardedMedalsBreakdown, SingleAcademyCalculation } from "../Api/competitorResultsApi";
    import { translate } from "../Common/translations";
    import { computed } from "vue";

    //TODO: Refactor to iterate over medalsSchema instead of checking just 4th place.
    const props = defineProps<{
        mergedResult: SingleAcademyCalculation;
        medalsSchema?: number[];
    }>();

    const getMedalCounter = (ruleBreakdown: AwardedMedalsBreakdown, place: number) => {
        return ruleBreakdown.value.medals[place] ?? 0;
    };

    const useExtendedClassification = computed(() => {
        return props.mergedResult.ruleBreakdowns.some(ruleBreakdown => {
            if (ruleBreakdown.type === "awardedMedalsBreakdown") {
                return ruleBreakdown.value.useExtendedClassification;
            }
            return false;
        });
    });
</script>

<style scoped></style>
